<template>
  <div>
    <v-snackbar absolute top :timeout="3000" v-model="snackbar">{{
      snackbarText
    }}</v-snackbar>
    <v-container fluid class="fill-height">
      <v-row class="pa-0 ma-0">
        <v-col cols="12" sm="12" md="12">
          <h1 class="page-title mt-5">Información de Cuenta</h1>
          <!-- <hr class="title-hr"> -->
        </v-col>
      </v-row>
      <span class="ml-10 mt-10 mb-5 font-weight-bold">Información General</span>
      <v-row class="ml-10 mr-10 cont">
        <v-col cols="12" sm="10" md="10">
          <v-text-field
            v-model="userInfo.displayName"
            label="Nombre del usuario"
            :loading="updatingName"
            v-on:keyup.enter="updateName"
            clearable
            class="mt-3"
            rounded
            filled
          ></v-text-field>
        </v-col>
        <v-col style="text-align: end" cols="12" sm="2" md="2">
          <v-btn
            :loading="updatingName"
            @click="updateName"
            class="mt-5"
            block
            color="btn-color"
            >Actualizar</v-btn
          >
        </v-col>
      </v-row>

      <span class="ml-10 mt-10 mb-5 font-weight-bold">Seguridad</span>
      <v-row class="ml-10 mr-10 cont">
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            v-model="currentPassword"
            :type="showPassword ? 'text' : 'password'"
            label="Contraseña actual"
            :loading="updatingPassword"
            autocomplete="new-password"
            value=""
            class="mt-3"
            rounded
            filled
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="3" md="3">
          <v-text-field
            v-model="password"
            :type="showPassword ? 'text' : 'password'"
            label="Nueva contraseña"
            :loading="updatingPassword"
            autocomplete="new-password"
            value=""
            class="mt-3"
            rounded
            filled
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="3" md="3">
          <v-text-field
            v-model="confirmPassword"
            class="mt-3"
            :type="showPassword ? 'text' : 'password'"
            label="Confirmar contraseña"
            :loading="updatingPassword"
            autocomplete="new-password"
            value=""
            clearable
            rounded
            filled
            v-on:keyup.enter="updatePassword"
          ></v-text-field>
        </v-col>

        <v-col style="cursor: pointer" class="mt-7 d-none d-md-block d-sm-block" cols="12" sm="1" md="1">
          <v-icon
            style="font-size: 20px !important"
            @click="showPassword = !showPassword"
          >
            {{ showPassword ? "fas fa-eye-slash" : "fas fa-eye" }}
          </v-icon>
        </v-col>

        <v-col style="text-align: end" cols="12" sm="2" md="2">
          <v-btn
            :loading="updatingPassword"
            @click="updatePassword()"
            class="mt-5"
            block
            color="btn-color"
            >Actualizar</v-btn
          >
        </v-col>
      </v-row>
      <v-row
        :style="
          user.MFAConfigured
            ? 'background-color: rgba(162, 198, 155, 0.35)'
            : 'background-color: rgba(187, 186, 187, 0.14)'
        "
        class="ml-10 mr-10 mt-10 mfa"
      >
        <v-col cols="12" sm="10" md="10">
          <p
            :style="userDoc.MFAConfigured ? 'color:green' : 'color:black'"
            class="font-weight-bold mt-2"
          >
            Multi- Factor Authenication (MFA)
            {{ userDoc.MFAConfigured ? "activo" : "desactivado" }}
          </p>
        </v-col>
        <v-col style="text-align: end" cols="12" sm="2" md="2">
          <v-btn
            @click="mfaDialog"
            block
            class="mt-1 white--text"
            :color="userDoc.MFAConfigured ? 'red darken-4' : 'btn-color'"
            >{{ userDoc.MFAConfigured ? "Desactivar" : "Activar" }}</v-btn
          >
        </v-col>
      </v-row>
    </v-container>

    <v-dialog max-width="800px" v-if="dialog" v-model="dialog">
      <mfa @cancel="dialog = false" @configured="dialog = false" />
    </v-dialog>

    <v-dialog
      max-width="500px"
      v-if="removeFMADialog"
      v-model="removeFMADialog"
    >
      <remove-token
        ref="tokenDelete"
        @next="confirmRemoveToken"
        @cancel="removeFMADialog = false"
      />
    </v-dialog>

    <v-dialog
      persistent
      max-width="400px"
      v-if="tokenDialog"
      v-model="tokenDialog"
    >
      <token-input
        ref="tokenComponent"
        @cancel="
          tokenDialog = false;
          updatingPassword = false;
        "
        @insertedToken="updatePassword"
      />
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import TokenInput from "../components/tokenInput.vue";
import mfa from "./MFA";
import { db, fb } from "@/firebase";
import removeToken from "../components/removeToken";

export default {
  name: "Profile",
  components: {
    mfa,
    TokenInput,
    removeToken,
  },
  data() {
    return {
      dialog: false,
      removeFMADialog: false,
      loading: false,
      snackbar: false,
      snackbarText: "",
      tokenDialog: false,
      password: "",
      confirmPassword: "",
      currentPassword: "",
      updatingPassword: false,
      updatingName: false,
      showPassword: false,
      userInfo: {},
    };
  },

  computed: {
    ...mapState(["user", "userDoc"]),
  },
  methods: {
    mfaDialog() {
      if (!this.userDoc.MFAConfigured) {
        this.dialog = true;
      } else {
        this.removeFMADialog = true;
      }
    },
    confirmRemoveToken(token) {
      var httpRemoveMfaToken = fb
        .functions()
        .httpsCallable("httpRemoveMfaToken");
      httpRemoveMfaToken({
        token: token,
      })
        .then((result) => {
          this.snackbarText =
            "Factor de múltiple autenticación desactivado correctamente.";
          this.snackbar = true;
          this.removeFMADialog = false;
        })
        .catch((err) => {
          if (this.$refs.tokenDelete) this.$refs.tokenDelete.handleError();
        });
    },
    updatePassword(token) {
      if (this.validatePassword()) {
        if (token) {
          this.confirmPasswordChange(token);
        } else if (this.userDoc.MFAConfigured) {
          this.tokenDialog = true;
        } else {
          this.confirmPasswordChange();
        }
      }
    },
    confirmPasswordChange(token) {
      this.updatingPassword = true;
      var httpUpdatePassword = fb
        .functions()
        .httpsCallable("httpUpdatePassword");
      httpUpdatePassword({
        token: token ? token : "",
        currentPassword: this.currentPassword,
        password: this.password,
        confirmPassword: this.confirmPassword,
      })
        .then((result) => {
          this.updatingPassword = false;
          this.snackbarText = "Contraseña actualizada exitosamente.";
          this.snackbar = true;
          if (this.$refs.tokenComponent)
            this.$refs.tokenComponent.handleSuccess();

          fb.auth()
            .signOut()
            .then(() => {
              this.$store.state.selectedApp = "";
            });
        })
        .catch((err) => {
          switch (err.code) {
            case "invalid-argument":
              this.snackbarText = "La contraseña actual ingresada es incorrecta.";
              this.snackbar = true;
              if (this.$refs.tokenComponent) this.$refs.tokenComponent.cancel();
            break;

            case "weak-password":
              this.snackbarText = "La contraseña ingresada debe tener al menos 6 dígitos.";
              this.snackbar = true;
              if (this.$refs.tokenComponent) this.$refs.tokenComponent.cancel();
            break;

            case "internal" :
              if (this.$refs.tokenComponent) this.$refs.tokenComponent.tokenError();
            break;

            default:
              this.snackbarText = "Ocurrió un error desconocido, inténtelo nuevamente.";
              this.snackbar = true;
              if (this.$refs.tokenComponent) this.$refs.tokenComponent.cancel();
            break;
          }

          this.updatingPassword = false;
          
        });
    },
    updateName() {
      this.updatingName = true;
      var httpUpdateName = fb.functions().httpsCallable("httpUpdateName");
      httpUpdateName({
        name: this.userInfo.displayName,
      })
        .then((result) => {
          this.updatingName = false;
          this.snackbarText = "Nombre actualizado exitosamente.";
          this.snackbar = true;
        })
        .catch((err) => {
          this.updatingName = false;
          this.snackbarText =
            "Ocurrió un error inesperado, inténtelo nuevamente.";
          this.snackbar = true;
        });
    },
    validatePassword() {
      if ( !this.currentPassword || !this.password || !this.confirmPassword) {
        this.snackbarText = "Debe ingresar su contraseña anterior y su nueva contraseña.";
        this.snackbar = true;
        return false;
      } else if (this.password != this.confirmPassword) {
        this.snackbarText = "Las contraseñas no coinciden.";
        this.snackbar = true;
        return false;
      } else if (this.password.length < 6) {
        this.snackbarText = "La contraseña debe tener al menos 6 digitos.";
        this.snackbar = true;
        return false;
      } else {
        return true;
      }
    },
  },
  mounted() {
    this.userInfo = Object.assign({}, this.user);
  },
};
</script>

<style>
.mfa {
  border-radius: 5px;
}

.cont {
  background-color: rgba(187, 186, 187, 0.14);
  border-radius: 10px;
}
</style>